import { Controller } from "@hotwired/stimulus"

// A value with an Edit button that swaps in a form: Edit shows the form
// and focuses its field, Cancel puts the value back. The form submits as
// forms do; the page re-renders with the saved value.
export default class extends Controller {
  static targets = ["display", "form", "input"]

  edit() {
    this.displayTarget.hidden = true
    this.formTarget.hidden = false
    if (this.hasInputTarget) {
      this.inputTarget.focus()
      this.inputTarget.select()
    }
  }

  cancel() {
    this.formTarget.hidden = true
    this.displayTarget.hidden = false
  }
}
